class BundleLookSection extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;

    this.initialized = true;
    this.section = this.closest('[data-section-type="bundle-look"]');

    if (!this.section) return;

    this.sectionId = this.section.dataset.sectionId;
    this.productHandle = this.section.dataset.productHandle;
    this.currentVariant = {
      id: this.section.dataset.initialVariant,
      option1: this.section.dataset.initialVariantOption1,
    };
    this.abortController = null;

    this.initVariantFetching();
  }

  // initRepositioning() {
  //   const sectionWrapper = this.closest('.shopify-section');

  //   if (!sectionWrapper) return;

  //   this.placeholder = document.createComment('bundle-look-placeholder');
  //   sectionWrapper.after(this.placeholder);

  //   this.mobileQuery = window.matchMedia('(max-width: 767px)');
  //   this.sectionWrapper = sectionWrapper;
  // }

  initVariantFetching() {
    document.addEventListener('theme:variant:change', (event) => {
      const variant = event.detail?.variant;

      if (!variant?.id || this.currentVariant?.option1 === variant.option1) return;

      this.currentVariant = variant;
      this.fetchSection(this.currentVariant.id);
    });
  }

  async fetchSection(variantId) {
    if (!this.sectionId || !this.productHandle || !variantId) return;

    if (this.abortController) this.abortController.abort();

    this.abortController = new AbortController();
    const url = `${window.Shopify?.routes?.root}products/${this.productHandle}?sections=${this.sectionId}&variant=${variantId}`;

    this.section.setAttribute('aria-busy', 'true');

    try {
      const response = await fetch(url, {
        signal: this.abortController.signal,
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
      });
      const data = await response.json();
      const html = data?.[this.sectionId];

      if (!html) {
        this.section.removeAttribute('hidden');
        this.section.innerHTML = '';
        return;
      }

      const temp = document.createElement('div');
      temp.innerHTML = html;
      const freshSection = temp.querySelector(`[data-section-id="${this.sectionId}"]`);
      const freshInner = freshSection?.querySelector('[data-bundle-look-inner]');

      if (!freshSection || !freshInner) {
        this.section.removeAttribute('hidden');
        this.section.innerHTML = '';
        return;
      }

      this.section.innerHTML = freshInner.outerHTML;
      this.section.removeAttribute('hidden');
    } catch (error) {
      if (error?.name === 'AbortError') return;
      this.section.removeAttribute('hidden');
    }

    this.section.removeAttribute('aria-busy');
  }
}

if (!customElements.get('bundle-look-section')) {
  customElements.define('bundle-look-section', BundleLookSection);
}
